// extracted by mini-css-extract-plugin
export default {"root":"at0UWzGLE3uHfpUOGxPe","header":"_CUlb7TivYkPwD7INHbj","img":"N623hGi1aBRU7Ol0rjAZ","h2":"ZwceuvHR_0_fMvB9DZ2g","subheader":"zB_9ZtDToezTntvTmQFQ"};